// Shared menu-feature constants. Kept in a neutral module so page components don't
// import from one another (previously ProductPage imported these from
// BulkAddProductsPage - a page-to-page coupling).

import { Allergen, ProductLabel } from '@restaurant/types';

export const ALLERGENS: Allergen[] = Object.values(Allergen);
export const LABELS: ProductLabel[] = Object.values(ProductLabel);
export const ALLERGEN_SET: ReadonlySet<string> = new Set(ALLERGENS);

// When an option-group name is left blank in advanced mode, we still store a
// name — but a fully-localized one, so the storefront renders it in the
// customer's own display language rather than a single baked-in string.
export const REQUIRED_GROUP_NAME: Record<string, string> = {
  en: 'Required · pick 1',
  vi: 'Bắt buộc chọn 1',
  de: 'Pflicht · 1 wählen',
  pl: 'Wymagane · wybierz 1',
};
export const OPTIONAL_GROUP_NAME: Record<string, string> = {
  en: 'Optional',
  vi: 'Tuỳ chọn',
  de: 'Optional',
  pl: 'Opcjonalne',
};
